import React from 'react';
import { Flex, HStack } from '@cad-arc';
import { EventAdditionalInfosWrapper } from '../../../additional-infos/components/event-additional-infos-wrapper';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { EventNarrative } from '../../../event-narrative';
import { EVENT_SUMMARY_SECTION_WIDTH } from '../../../fr-event-common-components/constants';
import { FrEventSummary } from '../../../fr-event-common-components/fr-event-summary';
import { useOpenFrEventDetails } from '../../hooks/use-open-fr-event-details';
import { FR_EVENT_DETAILS_TABS } from '../../constants';
import { FrTabContentWrapper, TOTAL_USED_PAGE_HEIGHT_WITHOUT_TAB_CONTENT_PADDING } from './styled';

export default function FrNarrativeTab() {
    const openFrEventDetails = useOpenFrEventDetails();
    const { rollOutFrFooterAndTabRedesignEnabled } = useEnabledFeatures();

    const onOpenFrEventDetails = (eventId: number) => {
        openFrEventDetails(eventId, FR_EVENT_DETAILS_TABS.EVENT_INFO);
    };

    if (rollOutFrFooterAndTabRedesignEnabled) {
        return (
            <FrTabContentWrapper $noDefaultPadding>
                <HStack h="100%" w="100%">
                    <Flex
                        width={`calc(100% - ${EVENT_SUMMARY_SECTION_WIDTH})`}
                        height="100%"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <EventAdditionalInfosWrapper>
                            <EventNarrative onOpenEvent={onOpenFrEventDetails} />
                        </EventAdditionalInfosWrapper>
                    </Flex>
                    <FrEventSummary
                        height={`calc(100vh - ${TOTAL_USED_PAGE_HEIGHT_WITHOUT_TAB_CONTENT_PADDING}px)`}
                    />
                </HStack>
            </FrTabContentWrapper>
        );
    }

    return (
        <FrTabContentWrapper>
            <EventAdditionalInfosWrapper>
                <EventNarrative onOpenEvent={onOpenFrEventDetails} />
            </EventAdditionalInfosWrapper>
        </FrTabContentWrapper>
    );
}
